import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AnalyticsUiModule } from '@cigna/shared/angular/analytics-ui';
import { CignaForBrokersSharedUtilModule } from '@cigna/cigna-for-brokers/shared/util';

import { LoginDataAccessTrackHandlers } from './services/login-data-access-track-handlers';

import { LoginEffects } from './+state/login.effects';
import { LOGIN_FEATURE_KEY, loginReducer } from './+state/login.reducer';

@NgModule({
  imports: [
    CommonModule,
    CignaForBrokersSharedUtilModule,
    StoreModule.forFeature(LOGIN_FEATURE_KEY, loginReducer),
    EffectsModule.forFeature([LoginEffects]),
    AnalyticsUiModule.withHandlers([LoginDataAccessTrackHandlers]),
  ],
})
export class CignaForBrokersLoginDataAccessModule {}
